import * as React from "react";
import { IListObj } from "../types/genericTypes";
import "../../assets/scss/components/generic/autocomplete.scss";

export interface IAutocompleteProps {
	name: string; // name of the input field
	className?: string; // extra classname for container if required
	data: Array<IListObj> | null; // dropdown array
	noDataMsg: string; // msg to show when data does not exist in dropdown array
	inputClassName?: string; // extra classname for input field
	errorText?: string; // red error text
	prefix?: React.ReactChild; // text/element to show before the input field
	suffix?: React.ReactChild; // text/element to show after the input field
	placeholder?: string; // placeholder
	helpText?: string; // help text
	helpTextColor?: "grey" | "blue"; // the color of help text, takes gray as default
	onOptionSelect: (data: IListObj) => void; // function to implement on input select
	onChange: (value: string) => void; // function to be called on change
	onBlur?: (value: string) => void; // function to be called on blur
}

const Autocomplete: React.FC<IAutocompleteProps> = (props) => {
	const [show, setShowDropdown] = React.useState(false);

	// sets the default value of input if present
	// value: value of the input (type = string)
	// setValue: function to set value
	const [value, setValue] = React.useState("");

	// when focussed, this helps to colour the border of input_field_cont
	const [focusClass, setFocusClass] = React.useState("");

	function showDropdown(value: string) {
		value ? setShowDropdown(true) : setShowDropdown(false);
	}

	function handleBlur() {
		hideDropDown();
		props.onBlur && props.onBlur(value);
	}

	function hideDropDown() {
		setTimeout(() => setShowDropdown(false), 300);
	}

	function handleInputChange(value: string) {
		showDropdown(value);
		setValue(value);
		return props.onChange(value);
	}

	function onOptionSelect(d: IListObj) {
		setShowDropdown(false);
		setValue(d.display);
		return props.onOptionSelect(d);
	}

	const dropdownList = props.data
		? props.data.map((d) => {
				const dropdownData = d.display.replace(new RegExp(value, "i"), "<b>$&</b>");

				return (
					<li className="dropdown_list" key={d.value} onClick={() => onOptionSelect(d)}>
						<div className="dropdown_data">
							<span dangerouslySetInnerHTML={{ __html: dropdownData }}></span>
						</div>
					</li>
				);
		  })
		: null;

	return (
		<div className={"autocomplete " + props.className}>
			<div className={"input_field_wrapper " + props.inputClassName}>
				<div className={"input_field_cont" + (props.errorText ? " error" : focusClass)}>
					{props.prefix && <div className="input_prefix">{props.prefix}</div>}
					<input
						name={props.name}
						id={props.name}
						value={value}
						onChange={(e) => handleInputChange(e.target.value)}
						placeholder={props.placeholder}
						className="input_field"
						onFocus={() => setFocusClass(" focus")}
						onBlur={handleBlur}
						autoComplete="off"
					/>
					{props.suffix && <div className="input_suffix">{props.suffix}</div>}
				</div>
				{props.errorText && <p className="help_text red">{props.errorText}</p>}
				{props.helpText && <p className={`help_text ${props.helpTextColor || "grey"}`}>{props.helpText}</p>}
			</div>
			<ul className={"dropdown" + (show ? " active" : "")} id="dropdown">
				{dropdownList !== null && (dropdownList.length ? dropdownList : <li className="no-data-msg">{props.noDataMsg}</li>)}
			</ul>
		</div>
	);
};

export default Autocomplete;
